import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-play-next',
  templateUrl: './icon-play-next.component.html',
  styleUrls: ['./icon-play-next.component.scss']
})
export class IconPlayNextComponent implements OnInit {
@Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
